import React, { useContext, useEffect, useRef, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import LazyLoading from '../../../components/LazyLoading';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { SocietyClientDataForm } from '../../../app/models/SocietyClient';
import { ClientContact } from '../../../app/models/ClientContact';
import useSocietyClientService from '../../../app/services/hooks/useSocietyClientService';
import SocietyClientForm from './forms/SocietyClientForm';
import { Client } from '../../../app/models/Client';
import useClientContactService from '../../../app/services/hooks/useClientContactService';
import useBusinessNameContactService from '../../../app/services/hooks/useBusinessNameContactService';

interface Props {
    societyId?: number;
    onSaved?: () => void;
    onCancel?: () => void;
    onError?: () => void;
}

const SocietyClientCreate = ({ societyId, onSaved, onCancel, onError }: Props) => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const [clientContacts, setClientContacts] = useState<ClientContact[]>([]);
    const [clients, setClients] = useState<Client[]>([]);
    const [societyClient, setSocietyClient] = useState<SocietyClientDataForm>(
        {
            society_id: societyId,
            client_id: 0,
            account_number: ''
        }
    )

    const clientIdSelected = useRef<number | undefined>(0);

    const [errorFields, setErrorFields] = useState<any>();

    const { fetchingStoreSocietyClient, storeSocietyClient, fetchingCreateSocietyClient, createSocietyClient } =
        useSocietyClientService();

    const {
        fetchingGetBusinessNameContactsByClient,
        getBusinessNameContactByClient
    } = useBusinessNameContactService()

    useEffect(() => {
        if (showLoading) showLoading('loading', 'Cargando datos...');

        createSocietyClient({
            onSuccess: (response: ServiceResponse) => {

                const clients = response.data.clients.map((client: Client) => {
                    return {
                      ...client,
                      account_number: `${societyId}-${client.business_name_id}`
                    };
                  });
                
                setClients(clients);
               
                if (hideLoading) hideLoading();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                toast.error(response.message);
                if (onError) onError();
            }
        });
    }, []);

    useEffect(() => {

        if (societyClient.client_id == undefined) {
            clientIdSelected.current = undefined;
        }

        if (societyClient.client_id && societyClient.client_id != clientIdSelected.current) {

            getBusinessNameContactByClient(societyClient.client_id, {
                    onSuccess: (response: ServiceResponse) => {

                        clientIdSelected.current = societyClient.client_id ?? 0;
                        setErrorFields(undefined);

                        setClientContacts(response.data.client_contacts);
                        setSocietyClient(
                            {
                                ...societyClient,
                                business_name_contact_id: undefined
                            }
                        )
                       
                    },
                    onError: (response: ServiceResponse) => {
                        setSocietyClient({
                            ...societyClient,
                            client_id: clientIdSelected.current
                        });
                    }
                })
                
            }
    }, [societyClient.client_id]);

    const store = () => {
   
        if (showLoading) showLoading('loading', 'Guardando cliente...');
        storeSocietyClient(societyClient, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                toast.success(response.message, {
                    autoClose: 2500
                });
                if (onSaved) onSaved();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            },
            onFieldError: (errorFields: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setErrorFields(errorFields.data);
            }
        });
    };

    const cancel = () => {
        if (onCancel) onCancel();
    };

    // if (errorGetData !== '') {
    //     return <div>{errorGetData}</div>;
    // }

    return fetchingCreateSocietyClient ? (
        <LazyLoading height={300} />
    ) : (
        <>
            <div className="row">
                <div className="col-12">
                    <SocietyClientForm
                        societyClientForm={societyClient}
                        setSocietyClientForm={setSocietyClient}
                        clientContacts={clientContacts}
                        clients={clients}
                        loadingClientContact={fetchingGetBusinessNameContactsByClient}
                        errorFields={errorFields}
                        setErrorFields={setErrorFields}
                    />
                </div>
            </div>
            <hr />
            <div className="row justify-content-end">
                <div className="col-auto">
                    <ButtonCancelForm callbackCancel={cancel} locked={fetchingStoreSocietyClient} />
                </div>
                <div className="col-auto">
                    <ButtonSaveForm callbackSave={store} locked={fetchingStoreSocietyClient} />
                </div>
            </div>
        </>
    );
};

export default SocietyClientCreate;
